
import { CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export function CompletedScreen() {
  return (
    <div className="text-center py-10 space-y-6">
      <div className="mx-auto bg-green-50 w-20 h-20 rounded-full flex items-center justify-center">
        <CheckCircle className="h-10 w-10 text-green-500" />
      </div>
      <h1 className="text-2xl md:text-3xl font-bold mb-4">Onboarding Complete!</h1>
      <p className="text-slate-600 mb-8 max-w-md mx-auto">
        Congratulations! You've completed all the steps to become a Cray Cray reposter.
      </p>
      <Button asChild size="lg" className="px-8">
        <a href="/">Return Home</a>
      </Button>
    </div>
  );
}
